import { Button, CircularProgress } from '@frontierag/frontier-ui-library';

import styles from './styles';
import type { ILoadingButton } from './types';

export default function LoadingButton({ loading, disabled, children, ...rest }: ILoadingButton) {
  return (
    <Button {...rest} disabled={disabled || loading}>
      {children}
      {loading && <CircularProgress size={20} color="primary" sx={styles.loader} />}
    </Button>
  );
}
